import React, { useMemo, useRef } from "react";
import { CSVLink } from "react-csv";
import { Tooltip, Button } from "ui";
import { Accordion, Spinner } from "react-bootstrap";
import { FiletypeCsv, FunnelFill } from "react-bootstrap-icons";
import { TRANSACTIONS_TABLE_COLUMNS } from "../constant";
import { TransactionsForm } from "./form";
import { transaction, TransactionDTO } from "features/transactions-list/type";
import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from "react-query";
import { AxiosError } from "axios";

interface ActionBarProp {
  transactions: transaction[];
  isLoading?: boolean;
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
  ) => Promise<QueryObserverResult<TransactionDTO, AxiosError<unknown, any>>>;
}

export const ActionBar: React.FC<ActionBarProp> = ({
  transactions,
  refetch,
  isLoading,
}) => {
  const csvLinkRef = useRef();
  const csvData = useMemo(() => {
    return transactions?.map((item, index) => [
      index.toLocaleString(),
      item.referenceNumber || "-",
      item.trackingNumber || "-",
      item.buyID || "-",
      Number(item.amount).toLocaleString() || "-",
      item.date || "-",
      item.time || "-",
      item.statusText || "-",
      item.cardNumber || "-",
    ]);
  }, [transactions]);

  return (
    <div className={"custom-box w-100 d-flex gap-2 justify-content-between"}>

      <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header><FunnelFill /></Accordion.Header>
        <Accordion.Body>
        <TransactionsForm  isLoading={isLoading}/>
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      {csvData && (
        <CSVLink
          data={csvData}
          headers={
            TRANSACTIONS_TABLE_COLUMNS.filter(
              (item) => item.id !== "expander"
            ).map((item) => item.header) as string[]
          }
          filename="poolban"
          //@ts-ignore
          ref={csvLinkRef}
        />
      )}
      <Tooltip color="dark" title="فایل اکسل">
        <Button
          className="h-100"
          variant="secondary"
          size="sm"
          onClick={() =>
            refetch().then((e) => {
              if (csvLinkRef.current) {
                //@ts-ignore
                csvLinkRef.current.link.click();
              }
            })
          }
        >
          {isLoading ? <Spinner size={"sm"} /> : <FiletypeCsv size={22} />}
        </Button>
      </Tooltip>
    </div>
  );
};
